/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const SignUpUser = /* GraphQL */ `
  mutation SignUpUser($input: SignUpUserInput) {
    SignUpUser(input: $input)
  }
`;
export const recordActivity = /* GraphQL */ `
  mutation RecordActivity($input: recordActivityInput) {
    recordActivity(input: $input)
  }
`;
export const upload_to_url = /* GraphQL */ `
  mutation Upload_to_url($key: String) {
    upload_to_url(key: $key)
  }
`;
export const GetNotifications = /* GraphQL */ `
  mutation GetNotifications($user_id: String!) {
    GetNotifications(user_id: $user_id) {
      items {
        notification_type
        user_id
        created_on
        notification_id
        notification_message
        notification_by
        license_plate_number
        notified_by_user_name
        __typename
      }
      lastEvaluatedKey
      user_id
      __typename
    }
  }
`;
export const RequestForProfile = /* GraphQL */ `
  mutation RequestForProfile($input: RequestForProfileInput) {
    RequestForProfile(input: $input)
  }
`;
export const UpdateProfile = /* GraphQL */ `
  mutation UpdateProfile($input: UpdateProfileInput) {
    UpdateProfile(input: $input)
  }
`;
export const InitiateViolation = /* GraphQL */ `
  mutation InitiateViolation($input: InitiateViolationInput) {
    InitiateViolation(input: $input)
  }
`;
export const DeleteUser = /* GraphQL */ `
  mutation DeleteUser($input: DeleteUserInput) {
    DeleteUser(input: $input)
  }
`;
export const CreateChat = /* GraphQL */ `
  mutation CreateChat($input: CreateChatInput) {
    CreateChat(input: $input)
  }
`;
export const updatePoliceLatLong = /* GraphQL */ `
  mutation UpdatePoliceLatLong($input: updatePoliceLatLongInput) {
    updatePoliceLatLong(input: $input)
  }
`;
export const SendMessage = /* GraphQL */ `
  mutation SendMessage(
    $chat_id: String!
    $message_text: String!
    $message_type: MessageTypeEnum!
    $messaged_by_id: String!
    $message_sent_type: MessagSentTypeEnum!
    $has_reply_message: Boolean!
    $no_of_replies: Int!
    $replied_to_message_id: String!
    $replied_for_message_type: MessageTypeEnum!
    $replied_for_message_text: String!
    $self_message: Boolean!
  ) {
    SendMessage(
      chat_id: $chat_id
      message_text: $message_text
      message_type: $message_type
      messaged_by_id: $messaged_by_id
      message_sent_type: $message_sent_type
      has_reply_message: $has_reply_message
      no_of_replies: $no_of_replies
      replied_to_message_id: $replied_to_message_id
      replied_for_message_type: $replied_for_message_type
      replied_for_message_text: $replied_for_message_text
      self_message: $self_message
    ) {
      chat_id
      message_text
      messaged_by_id
      messaged_by_user_details
      message_id
      messaged_on
      message_type
      message_sent_type
      has_reply_message
      no_of_replies
      replied_to_message_id
      replied_for_message_type
      replied_for_message_text
      reactions {
        chat_id
        reaction_id
        message_id
        reacted_time
        reacted_by_user_id
        reacted_by_user_first_name
        reacted_by_user_last_name
        reaction_type
        __typename
      }
      __typename
    }
  }
`;
export const GetVideoCall = /* GraphQL */ `
  mutation GetVideoCall(
    $chat_id: String!
    $video_status: VideoCallStatusEnum!
  ) {
    GetVideoCall(chat_id: $chat_id, video_status: $video_status) {
      chat_id
      video_status
      __typename
    }
  }
`;
export const fire_notification_for_every_message = /* GraphQL */ `
  mutation Fire_notification_for_every_message(
    $input: fire_notification_for_every_message_input
  ) {
    fire_notification_for_every_message(input: $input)
  }
`;
export const favouriteViolations = /* GraphQL */ `
  mutation FavouriteViolations($input: favourite_violations_input) {
    favouriteViolations(input: $input)
  }
`;
